import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatDate } from '../../../common/Utilities';

export default function ReportInfoHeader({
  project, 
  startDate,
  endDate
}) {

  if (!Object.keys(project).length) {
    return ''
  }

  let projectName = '';
  let projectCode = '';
  let projectManagerName = '';
  let clientName = '';

  if (typeof(project.project_name) !== "undefined") {
    projectName = project.project_name;
  }

  if (typeof(project.project_code) !== "undefined") {
    projectCode = project.project_code;
  }
  
  if (typeof(project.project_manager) !== "undefined") {
    const projectManager = project.project_manager;

    if (projectManager)  {
      if (Object.keys(projectManager).length) {
        projectManagerName = projectManager.first_name + " " + projectManager.last_name;
      }
    }
  }

  if (typeof(project.client) !== "undefined") {
    const client = project.client;
    if (Object.keys(client).length) {
      clientName = client.client_name;
    }
  }

  return (
    <>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Client Name</b></Col>
        <Col>{clientName}</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Project Name</b></Col>
        <Col>{projectName}</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Project Code</b></Col>
        <Col>{projectCode}</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>MS Manager</b></Col>
        <Col>{projectManagerName}</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Start Date</b></Col>
        <Col>{ formatDate(new Date(project.start_date)) }</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>End Date</b></Col>
        <Col>{ formatDate(new Date(project.end_date)) }</Col>
      </Row>
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Report Filter Date:</b></Col>
        <Col>{ formatDate(startDate) } - { formatDate(endDate) }</Col>
      </Row>
    </>
  )
}
